export const AWS_URL = "https://janustourbuilder.s3.ca-central-1.amazonaws.com/";